import "./banner/Banner.css";
import React, { useState } from "react";
import Banner from "./banner/Banner";
import Demo_Product from "./demo_product/Demo_Product";
import All_Time_Fav from "./all_time_fav/All_Time_Fav";
import Product_vdo_preview from "./product_vdo_preview/Product_vdo_preview";
import Farming_on_purpose from "./farming_on_purpose/Farming_on_purpose";
import Farm_vdo from "./farm_vdo/Farm_vdo";
import Harvested_By_you from "./harvested_by_you/Harvested_By_you";
import Our_philosophy from "./our_philosophy/Our_philosophy";
import Explore_our_fresh_produce from "./explore_our_fresh_produce/Explore_our_fresh_produce";
import Philosophy_grounded_in_nature from "./philosophy_grounded_in_nature/Philosophy_grounded_in_nature";
import Testimonials from "./testimonials/Testimonials";
import Food_and_wellness_journal from "./food_and_wellness_journal/Food_and_wellness_journal";
import Stay_Connected from "./stay_Connected/Stay_Connected";
import Category_section from "./category-section/Category_section";
import { useDispatch, useSelector } from "react-redux";
import { AllShape, getAllCategories } from "../../features/master/masterSlice";
import { useEffect } from "react";
import {
  getAllProducts,
  getAllTimeFavsProducts,
} from "../../features/products/productsSlice";
import {
  getHomeBanner,
  getHomeShopAndWatch,
} from "../../features/home/homeSlice";
import Demo_ProductCategory from "./demo_product/Demo_ProductCategory";
import { getAboutUs } from "../../features/aboutus/aboutusSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageSwipper from "./image_swipper/Image_Swipper";
import Shop_By_Shape from "./shop_by_shape/Shop_By_Shape";
import Reels from "./reels/Reels";

function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  AOS.init({ disable: "mobile" });

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const [shapeId, setShapeId] = useState();
  const productdata = useSelector((state) => state.product.allProductsFavs);
  useEffect(() => {
    dispatch(
      getAllTimeFavsProducts({
        shape_id: shapeId?.id,
      }),
    );
  }, [dispatch, shapeId]);

  const banner = useSelector((state) => state.home.banners);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  const about_us = useSelector((state) => state.aboutus.about_us);

  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const shapes = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  const watch_and_shop = useSelector(
    (state) => state.home.all_home_shop_and_watch,
  );

  useEffect(() => {
    dispatch(getHomeShopAndWatch());
  }, [dispatch]);

  return (
    <>
      <Banner banner={banner} />
      <Category_section />
      {/* <Shop_By_Shape shapes={shapes} setShapeId={setShapeId} /> */}
      {/* <ImageSwipper/> */}
      {/* <div className="home_Demo_Product_holder">
        <Demo_ProductCategory products={category} breakpoints={breakpoints} />
      </div> */}
      <Product_vdo_preview about_us={about_us} />
      <All_Time_Fav products={productdata} />
     




      {/* <Farming_on_purpose /> */}
      {/* <Farm_vdo about_us={about_us} /> */}
      {/* <Harvested_By_you  /> */}
      {/* <Harvested_By_you products={category} /> */}
      {/* <Our_philosophy /> */}
      {/* <Explore_our_fresh_produce /> */}
      {/* <Philosophy_grounded_in_nature /> */}
      {/* <Testimonials /> */}
      {/* <Food_and_wellness_journal /> */}
      {/* <Stay_Connected /> */}

      {watch_and_shop?.length > 0 && <Reels watch_and_shop={watch_and_shop} />}
      
    </>
  );
}

export default Home;
